'use client'

import type React from 'react'
import { useApp, useModals, useUser } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { CreateCustomer } from '@/components/molecules'

interface CreateCustomerModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const CreateCustomerModal = ({ open }: CreateCustomerModalProps) => {
  const { closeModal } = useModals()
  const { setUserPin } = useUser()
  const { setIsLoading } = useApp()

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setIsLoading(false)
          setUserPin([])
          closeModal('CREATE_CUSTOMER')
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('CREATE_CUSTOMER')}
        size="md"
      >
        <DialogHeader>
          <DialogTitle>Create Customer</DialogTitle>
          <DialogDescription>
            Create a new customer with the details below
          </DialogDescription>
        </DialogHeader>

        {open && (
          <div className="flex h-full w-full">
            <CreateCustomer />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
